import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

export const termsOfServiceLinksResolver: ResolveFn<void> = () => {
  return inject(AuthService).setTermsOfServiceLinks();
};
